<template>
  <div>
    <navbar :windowPositions="windowPositions" />
    <Slider />
    <About />
    <Feature />
    <Work />
    <Screenshots />
    <Team />
    <Package />
    <Testimonial />
    <FAQ />
    <Blog />
    <Download />
    <Footer />
    <Subscribe />
    <Copyright />
    <div id="fb-root"></div>
  </div>
</template>
<script>
import navbar from "@/components/navbar.vue";
import Slider from "@/components/slider.vue";
import About from "@/components/about.vue";
import Feature from "@/components/feature.vue";
import Work from "@/components/work.vue";
import Screenshots from "@/components/screenshots.vue";
import Team from "@/components/team.vue";
import Package from "@/components/package.vue";
import Testimonial from "@/components/testimonial.vue";
import FAQ from "@/components/faq.vue";
import Download from "@/components/download.vue";
import Footer from "@/components/footer.vue";
import Subscribe from "@/components/subscribe.vue";
import Copyright from "@/components/copy_right.vue";
import Blog from "@/components/blog.vue";
export default {
  name: "Index",
  data() {
    return {
      windowPositions: {
        sliderPosition: 0,
        aboutPosition: 0,
        featurePosition: 0,
        workPosition: 0,
        screenshotsPosition: 0,
        teamPosition: 0,
        packagePosition: 0,
        testimonialPosition: 0,
        faqPosition: 0,
        downloadPosition: 0,
        footerPosition: 0,
        subscribePosition: 0,
        copyrightPosition: 0,
        blogPosition: 0,
      },
    };
  },
  components: {
    navbar,
    Slider,
    About,
    Feature,
    Work,
    Screenshots,
    Team,
    Package,
    Blog,
    Testimonial,
    FAQ,
    Download,
    Footer,
    Subscribe,
    Copyright,
  },
  mounted: function () {
    document.body.classList.remove("inner-page");
  },
  methods: {
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, 500);
    },
    setPosition(value) {
      let name = value.name;
      this.windowPositions[name] = value.position;
    },
  },
};
</script>
